import React, { useMemo } from 'react';
import { RailsBlock } from '@sls-react/typings/services/rails/tile';
import useTileVersion from '@sls-react/hooks/useTileVersion';
import { darken } from 'polished';
import { Button } from '@sls-react/components/Form/Button';

interface Props {
  block: RailsBlock;
}

const BlockButton: React.FC<Props> = ({ block }) => {
  const tileVersion = useTileVersion(block);

  const color = useMemo(() => {
    let c;

    if (!tileVersion.button_color?.startsWith('#')) {
      c = `#${tileVersion.button_color}`;
    } else {
      c = tileVersion.button_color || '#02c874';
    }

    return c;
  }, [tileVersion.button_color]);

  const darkened = useMemo(() => {
    return darken(0.05, color);
  }, [color]);

  if (tileVersion.destination) {
    return (
      <a href={tileVersion.destination}>
        <Button
          className="mt-4"
          css={`
            background-color: ${tileVersion.button_color || '#02c874'};
            border-color: ${tileVersion.button_color || '#02c874'};

            &:hover {
              background-color: ${darkened};
              border-color: ${darkened};
            }
          `}
        >
          {tileVersion.button_text || tileVersion.title}
        </Button>
      </a>
    );
  }

  return null;
};

export default BlockButton;
